<template>
    <Stepper />

    <div class="content__container top">
        <div>
            <span>Программа</span>
            <p>"Чемпион"</p>
        </div>
        <div>
            <span>Стоимость</span>
            <p>{{ contractStore.price.toFixed(2) }} ₽</p>
        </div>
    </div>

    <form ref="champion_form" class="content__container middle" @submit.prevent="createContractAndPaymentBill">
        <h2>Оформление</h2>
        
        <h3 class="middle__title">Страхователь</h3>
        <div class="middle__row insurer">
            <PersonFields
                :person="insurer" 
                id="insurer"
                :disabledMiddleName="insurer.has_middle_name"
                :errors="errorsInsurer"
            />
        </div>

        <p class="row__divider">Дата рождения</p>
        <div class="middle__row fill">
            <Input v-model="insurer.birth_date" type="date" :error="errorsInsurer.birth_date" />
            <Input v-model="insurer.email" placeholder="E-mail" type="email" :error="errorsInsurer.email" />
            <Input v-model="insurer.phone" placeholder="Мобильный телефон" type="tel" :error="errorsInsurer.phone" />
        </div>

        <div class="checkbox checkbox--makc checkbox--makc-giant">
            <input v-model="insurerIsInsured" @change="dublicateInfo" class="checkbox__input" type="checkbox" id="checkbox1">
            <label class="checkbox__label" for="checkbox1">
                <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                </span>
                <span class="checkbox__label--text">
                    Страхователь является Застрахованным 
                </span>
            </label>
        </div>

        <div class="wrapper"></div>

        <h3 class="middle__title">Застрахованный</h3>
        <div class="middle__row" v-for="(item, index) in insured">
            <PersonFields
                :person="item" 
                :id="`insured-${index}`"
                withDate
                deleter
                :disabled="index === 0 && insurerIsInsured"
                :disabledMiddleName="item.has_middle_name || index === 0 && insurerIsInsured"
                :canBeDeleted="insured.length === 1"
                :errors="errors[index]"
                @delete="insured.length === 1 ? null : insured.splice(index, 1)"
            />
        </div>
        <div class="add-person" >
            <Button v-if="insured.length < 30" label="+ Добавить застрахованного" className="select" type="button" @click="insured.push({birth_place: '', citizenship: 'rf',sex: '0'})" />
        </div>

        <div class="wrapper"></div>

        <h3 class="middle__title">Срок страхования</h3>
        <div class="middle__duration">
            <Input v-model="contractStore.champion.startDate" type="date" disabled />
            <Input v-model="contractStore.champion.endDate" type="date" disabled />
        </div>

        <div class="wrapper"></div>

        <div class="checkbox checkbox--makc checkbox--makc-giant" :class="{'required': !politycs[index].check && statusOfValidation}" v-for="(item, index) in politycs">
            <input v-model="item.check" class="checkbox__input" type="checkbox" :id="`politycs-${index}`">
            <label class="checkbox__label" :for="`politycs-${index}`">
                <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                </span>
                <span class="checkbox__label--text">
                    {{ item.text }}&nbsp;
                    <a class="clp-link clp-link--makc" :href="item.link" target="_blank" @click="(e) => {if (!item.link) e.preventDefault()}">
                        {{ item.linkText }} 
                    </a>
                    <span v-if="item.link2"> и </span>
                    <a v-if="item.link2" class="clp-link clp-link--makc" :href="item.link2" target="_blank">
                        {{ item.linkText2 }} 
                    </a>
                </span>
            </label>
        </div>

        <div class="wrapper"></div>

        <SocialCards :socialCardInfo="socialCardInfo" @checker="socialCardInfo.socialCardType = ''" />

        <div class="middle__actions">
            <Button label="Назад" className="infomation" @click="$router.back()" />
            <Button :label="creatingContractProcess ? 'Формируем счет...' : 'Оплатить'" className="confirm" type="submit" :disabled="creatingContractProcess" />
        </div>
    </form>

</template>

<script>
import Button from '@/create/components/UI/buttons/Button.vue';
import Input from '@/create/components/UI/inputs/Input.vue';
import Tabs from '@/create/components/UI/list/Tabs.vue';
import { useContractsStore } from '@/create/store/contracts';
import Stepper from '@/create/components/Stepper.vue';
import PersonFields from '@/create/components/PersonFields.vue';
import SocialCards from '@/create/components/SocialCards.vue';
import { getAge, personValidate } from '@/create/composables/validators';
import { localDevelopment, subdomain, testDevelopment } from '../composables/const';
import { dateFormatter } from '@/create/composables/utils';

    export default {
        components: {
            Button,
            Input,
            Tabs,
            Stepper,
            PersonFields,
            SocialCards,
        },
        data() {
            return {
                contractStore: useContractsStore(),
                insurer: {birth_place: '', citizenship: 'rf', sex: '0', email: '', phone: ''},
                insurerIsInsured: false,
                insured: [{birth_place: '', citizenship: 'rf', sex: '0'}],

                politycs: [
                    {
                        check: false,
                        text: 'Согласен с',
                        linkText: 'Политикой обработки персональных данных',
                        link: 'https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php'
                    },
                    {
                        check: false,
                        text: 'Ознакомился с',
                        linkText: 'Ключевым информационным документом',
                        link: ''
                    },
                    {
                        check: false,
                        text: 'Ознакомился и согласился с',
                        linkText: 'Условиями полиса',
                        link: '',
                        linkText2: 'Правилами страхования',
                        link2: 'https://makclife.ru/b2b/life/rules/rulesForNS90.8.pdf'
                    },
                ],
                socialCardInfo: {},
                
                timeoutCalc: null,
                timeoutKid: null,
                creatingContractProcess: false,
                statusOfValidation: false,
                errorsInsurer: {},
                errors: [],
                
            }
        },
        computed: {
            agreements() {                                          // отслеживаем галочки согласия с политиками компании
                for (let i = 0; i < this.politycs.length; i++) {
                    const el = this.politycs[i];
                    if (el.check === false) return true
                }
                return false
            },
            structuredPersonsInfo() {                               // структурируем дату рождения и телефон при отправке на создание контракта,
                const nums = /([0-9]|[+])/g;                        // в экшоне get_kid и demon_create
                const personArray = structuredClone([this.insurer, ...this.insured])
                personArray.forEach(i => { if (i.birth_date && i.birth_date.length > 8) i.birth_date = dateFormatter('-', i.birth_date)});
                personArray.forEach(i => { if (i.phone) i.phone = i.phone.match(nums).join('')});
                return personArray
            },
            personsLength() {                                       // считаем количество застрахованных лиц, с учетом является ли страхователь застрахованным или нет
                const indexes = structuredClone([this.insurer, ...this.insured]).map((_, idx) => idx.toString())
                this.insurerIsInsured ? indexes.splice(1,1) : indexes.splice(0,1)
                return indexes
            },
            requestData() {
                return {
                    format: "json",
                    ver: 4,
                    object: "contract",
                    login: "critical",
                    agreement: {
                        program_type: 'cred',
                        program: "sport",
                        ins_calc_amount: this.contractStore.champion.sumStep,
                        ins_calc_type: '1',
                        ins_period: this.contractStore.champion.durationTerm,
                        ins_rules: true,
                        payment_order: '0',
                        currency: "rur",
                        insurer: 0,
                        status: 10,
                        bank_policy_premium: 0,
                        menu_id: '10',
                        date_start: dateFormatter('-', this.contractStore.champion.startDate),
                        discount: this.socialCardInfo.cardInputNumber ? 'Y' : 'N',
                        discount_card_type: this.socialCardInfo.socialCardType || '',
                        discount_card_series : this.socialCardInfo.cardInputSerial || '',
                        discount_card_number: this.socialCardInfo.cardInputNumber || '',
                        kinds_of_sports: this.contractStore.champion.chosenSports,
                    },
                    contacts: this.structuredPersonsInfo,
                }                                    
            },
        },
        methods: {
            dublicateInfo() {                                       // метод копирует данные страхователя в 1 позицию массива застрахованных,
                if (this.insurerIsInsured) this.insured[0] = this.insurer       // если установлена галочка, что страхователь является застрахованным
                else {
                    this.insured[0] = {...this.insurer}
                    delete this.insured[0].email
                    delete this.insured[0].phone
                }
            },
            getKidAndPolicy() {
                if (this.timeoutKid) {
                    clearTimeout(this.timeoutKid);
                }

                this.timeoutKid = setTimeout(async () => {
                    const temp = structuredClone(this.requestData)
                    temp.action = 'get_kid'
                    temp.agreement.insured = this.personsLength            // инфо застрахованных, учитывается в документе, но это не точно
                    temp.agreement.insurer_birth_date = dateFormatter('-', this.insurer.birth_date)
                    temp.agreement.insured_birth_date = this.insurerIsInsured ? dateFormatter('-', this.insurer.birth_date) : dateFormatter('-', this.insured[0].birth_date)
                    
                    try {
                        const res = await this.contractStore.getCalculation(temp)

                        if (res.data.state === 'success') {
                            const domain = localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru` : "https://makclife.ru";
                            this.politycs[1].link = domain + res.data.kid;
                            this.politycs[2].link = domain + res.data.project;
                        }
                    } catch (e) {
                        console.log('Frontend Error - ' + e);
                    }
                }, 1000);
            },
            getFullCalc() {                                   // итоговый расчет суммы контракта, но подсчет идет только на 1 человека
                if (this.timeoutCalc) {                             
                    clearTimeout(this.timeoutCalc);
                }

                this.timeoutCalc = setTimeout(async () => {
                    if (getAge(this.insurer.birth_date) < 18) return this.errorsInsurer.birth_date = 'минимальный возраст 18 лет'
                    else this.errorsInsurer.birth_date = ''

                    const temp = structuredClone(this.requestData)
                    temp.action = 'calc'
                    temp.agreement.insured_birth_date = '01.01.2005'
                    
                    let adults = 0
                    let adultsIndex = 0
                    let childs = 0
                    let childIndex = 0
                    for (let i = 0; i < this.insured.length; i++) {
                        const obj = this.insured[i];
                        if (!obj.birth_date) {
                            return                        // чтобы цена не пересчитывалась, если нет даты рождения у застрахованного
                        }
                        if (getAge(obj.birth_date) < 18) {
                            childs++
                            childIndex = i+1
                        } else {
                            adults++
                            adultsIndex = i+1
                        }
                    }
             
                    try {
                        temp.agreement.insured = adultsIndex.toString()
                        const res = await this.contractStore.getCalculation(temp)
                        if (res.data.state === 'success') {
                            this.socialCardInfo.discount = res.data.discount;
                        }
                        if (childs > 0) {
                            temp.agreement.insured = childIndex.toString()
                            temp.agreement.insured_birth_date = '01.01.2020'
                            const resChild = await this.contractStore.getCalculation(temp)
                            return this.contractStore.price = (resChild.data.ins_fee * 100 * childs + res.data.ins_fee * 100 * adults) / 100
                        }
                        return this.contractStore.price = (res.data.ins_fee * 100 * this.insured.length) / 100
                    } catch (e) {
                        console.log('Frontend Error - ' + e);
                    } 
                }, 900);
            },
            async createContractAndPaymentBill() {                  // создание контракта, после 1 покрытия приходит ответ с бека
                                                                    // с ссылкой на счет для оплаты - там сумма расчитывается на всех застрахованных
                
                let err = false
                this.errorsInsurer = personValidate(this.insurer, 18, 100)
                for (let i = 0; i < this.insured.length; i++) {
                    this.errors[i] = personValidate(this.insured[i])  
                    if (!!Object.keys(this.errors[i]).length) err = true   
                }
                if (!!Object.keys(this.errorsInsurer).length || err) {
                    return this.$refs.champion_form.scrollIntoView({ behavior: 'smooth'})
                }
                if (this.agreements) {
                    return this.statusOfValidation = true
                }

                const temp = structuredClone(this.requestData)
                temp.action = 'demon_create'
                temp.agreement.insured = this.personsLength,               // количество застрахованных, значение влияет на конечную сумму, но это не точно
                temp.documents = []

                try {
                    this.creatingContractProcess = true
                    const res = await this.contractStore.getCalculation(temp)
                    this.creatingContractProcess = false
                    if (res.data.state === 'success') {
                        window.open(res.data.url.link, '_self');
                    }
                } catch (e) {
                    this.creatingContractProcess = false
                    console.log('Frontend Error - ' + e);
                }
            },
        },
        mounted() {
            if (localStorage.getItem('contract')) this.contractStore.champion = JSON.parse(localStorage.getItem('contract'))        // предварительные данные для калькуляции из 1 страницы

            this.$watch(vm => [vm.insurer, vm.insurerIsInsured, vm.insured, vm.socialCardInfo ], () => {          // отслеживаем форму и производим калькуляцию
                this.getFullCalc()
                this.getKidAndPolicy()
            }, {
                immediate: true,
                deep: true
            })

            window.document.head.getElementsByTagName('title')[0].innerHTML = 'Чемпион'
        },


    }
</script>

<style lang="scss" scoped>
.top {
    margin-top: 50px;
    background-color: #f2f3f5;
    padding: 1.5rem 3rem;
    display: flex;
    justify-content: space-between;

    @media (max-width: 480px) {
        margin-top: 30px;
        padding: 1.5rem 10px;
    }

    span, p {
        color: #00509f;
    }

    p {
        margin-top: 15px;
        font-weight: 700;
    }
}

.middle {
    margin-top: 50px;
    background-color: #f2f3f5;
    padding: 1.5rem 3rem;

    @media (max-width: 480px) {
        margin-top: 30px;
        padding: 1.5rem 10px;
    }

    &__title {
        font-size: 1.25rem;
        margin: 1.5rem 0;

        @media (max-width: 480px) {
            font-size: 1rem;
            margin: 0.75rem 0;
        }
    }
    
    &__row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 2.5rem 0;

        @media (max-width: 480px) {
            flex-direction: column;
            gap: 5px;
        }
    }

    &__duration {
        display: flex;
        gap: 50px;
        
        .input__container {
            width: 300px;
        }

        @media (max-width: 480px) {
            flex-direction: column;
            gap: 10px;
            width: 100%;

            .input__container {
                width: 100%;
            }
        }
    }

    &__actions {
        margin-top: 50px;
        display: flex;
        gap: 30px;

        @media (max-width: 480px) {
            width: 100%;
            flex-direction: column;
            gap: 10px;
        }

        button {
            width: 250px;

            @media (max-width: 480px) {
                width: 100%;
            }
        }
    }
}

.row__divider {
    margin-top: 2rem;
    margin-bottom: -2rem;

    @media (max-width: 480px) {
        margin-top: 0;
    }
}

.add-person {
    button {
        width: 300px;
    }

    @media (max-width: 480px) {
        width: 100%;

        button {
            width: 100%;
        }
    }
}

.insurer {
    :deep(.input__container) {
        width: 23%;
        @media (max-width: 480px) {
            width: 100%;
        }
    }
}

.fill {
    .input__container {
        width: 30%;

        @media (max-width: 480px) {
            width: 100%;
        }
    }
}

.wrapper {
    width: 100%;
    height: 1px;
    background-color: gainsboro;
    margin: 3rem 0;
}

.disabled-link {
    pointer-events: none;
    text-decoration: none;
}

.required {
    span {
        color: #ff144f;
        border-color: #ff144f;
    }
}
</style>